/* CarGauge global header behaviour (Upgrade 02).
 * Small, dependency-free. The theme's own jQuery handlers still do the real work
 * (mobile drawer open/close, cart dropdown/drawer, AJAX search); this file only adds:
 *   - nav placement (desktop bar <-> mobile drawer) without the legacy sticky hack
 *   - sticky "scrolled" state
 *   - Escape / click-outside / focus handling and aria-expanded syncing
 *   - desktop dropdown + search popover toggles
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia ? window.matchMedia('(min-width: 1025px)') : { matches: true, addListener: function () {} };
  var observers = [];

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function header() { return $('[data-cg-header]'); }
  function isDesktopNav() { var n = document.getElementById('site-nav'); return !!n && n.classList.contains('site-nav'); }

  /* ---------- nav placement ---------- */
  function placeNav() {
    var nav = document.getElementById('site-nav');
    var slot = $('[data-cg-nav-slot]');
    var drawerSlot = $('#site-nav-mobile .site-nav-mobile-wrapper');
    if (!nav || !slot || !drawerSlot) return;
    if (DESKTOP.matches) {
      if (nav.parentNode !== slot) slot.appendChild(nav);
      nav.className = 'site-nav';
      closeMenu();
    } else {
      if (nav.parentNode !== drawerSlot) drawerSlot.appendChild(nav);
      nav.className = 'site-nav-mobile';
      closeDesktopDropdowns();
      closeSearch();
    }
    syncExpanded();
  }

  /* ---------- sticky scrolled state (hysteresis avoids toggling at the threshold) ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var h = header();
      if (h) {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (y > 40) h.classList.add('is-scrolled');
        else if (y < 8) h.classList.remove('is-scrolled');
      }
      ticking = false;
    });
  }

  /* ---------- desktop dropdowns ---------- */
  function closeDesktopDropdowns(except) {
    $$('#site-nav.site-nav .menu-lv-1.is-open').forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var b = $('.icon-dropdown', li);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- desktop search popover ---------- */
  function closeSearch(focusToggle) {
    var h = header();
    if (!h || !h.classList.contains('is-search-open')) return;
    h.classList.remove('is-search-open');
    var t = $('[data-cg-search-toggle]', h);
    if (t) { t.setAttribute('aria-expanded', 'false'); if (focusToggle) t.focus(); }
  }

  /* ---------- mobile drawer ---------- */
  function menuOpen() { return document.body.classList.contains('open_menu'); }
  function closeMenu() {
    if (!menuOpen()) return;
    var c = $('#site-nav-mobile .close_menu .close');
    if (c) c.click();
    else document.body.classList.remove('open_menu');
  }
  function drawerFocusables() {
    var d = $('#site-nav-mobile');
    if (!d) return [];
    return $$('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])', d).filter(function (el) {
      return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  /* ---------- aria-expanded syncing ---------- */
  function syncExpanded() {
    $$('[data-mobile-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', menuOpen() ? 'true' : 'false'); });
    $$('#site-nav-mobile li.dropdown').forEach(function (li) {
      var b = $('.nav-action > .icon-dropdown', li);
      if (b) b.setAttribute('aria-expanded', li.classList.contains('is-open') ? 'true' : 'false');
    });
    var ms = $('.item--searchMobile .navUser-action');
    if (ms) ms.setAttribute('aria-expanded', ms.classList.contains('is-open') ? 'true' : 'false');
  }

  var lastMenuState = false;
  function onBodyClass() {
    var open = menuOpen();
    syncExpanded();
    if (open === lastMenuState) return;
    lastMenuState = open;
    var toggle = $('[data-mobile-menu-toggle]');
    if (open) {
      window.setTimeout(function () { var f = drawerFocusables(); if (f.length) f[0].focus(); }, 60);
    } else if (toggle && (document.activeElement === document.body || $('#site-nav-mobile').contains(document.activeElement))) {
      toggle.focus();
    }
  }

  function onMobileSearchClass() {
    syncExpanded();
    var b = $('.item--searchMobile .navUser-action');
    if (b && b.classList.contains('is-open')) {
      var i = $('.item--searchMobile .header-search__input');
      if (i) window.setTimeout(function () { i.focus(); }, 60);
    }
  }

  /* ---------- cart badge: hide at 0 ---------- */
  function syncCount(n) {
    var v = (n.textContent || '').trim();
    n.classList.toggle('is-zero', v === '' || v === '0');
  }

  function observe(target, cb, opts) {
    if (!target || !window.MutationObserver) return;
    var o = new MutationObserver(cb);
    o.observe(target, opts);
    observers.push(o);
  }

  /* ---------- document-level listeners (bound once) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // chevron buttons
    var chev = t.closest('button.icon-dropdown[data-toggle-menu-mb]');
    if (chev) {
      var row = chev.closest('.nav-action');
      if (isDesktopNav()) {
        e.preventDefault();
        var li = chev.closest('.menu-lv-1');
        var willOpen = !li.classList.contains('is-open');
        closeDesktopDropdowns(li);
        li.classList.toggle('is-open', willOpen);
        chev.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      } else if (row) {
        // Keyboard activation: hand the click to the row so the theme's handler sees the
        // same event target it expects (pointer taps already land on the row).
        e.preventDefault();
        e.stopPropagation();
        row.click();
        syncExpanded();
      }
      return;
    }

    // desktop search toggle
    var st = t.closest('[data-cg-search-toggle]');
    if (st) {
      var h = header();
      var open = !h.classList.contains('is-search-open');
      h.classList.toggle('is-search-open', open);
      st.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var inp = $('.item--quickSearch .header-search__input', h); if (inp) inp.focus(); }
      return;
    }

    // click outside closes desktop popovers
    if (!t.closest('.menu-lv-1')) closeDesktopDropdowns();
    if (!t.closest('.item--quickSearch') && !t.closest('[data-cg-search-toggle]')) closeSearch();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var h = header();
      if (menuOpen()) { closeMenu(); return; }
      if (document.body.classList.contains('open_Cart')) { var cc = $('[data-close-cart-preview]'); if (cc) cc.click(); return; }
      if (document.body.classList.contains('open_Account')) { var ca = $('[data-close-login-dropdown]'); if (ca) ca.click(); return; }
      var ms = $('.item--searchMobile .navUser-action.is-open');
      if (ms) { ms.click(); ms.focus(); return; }
      if (h && h.classList.contains('is-search-open')) { closeSearch(true); return; }
      var openLi = $('#site-nav.site-nav .menu-lv-1.is-open');
      if (openLi) {
        var b = $('.icon-dropdown', openLi);
        closeDesktopDropdowns();
        if (b) b.focus();
      }
      return;
    }
    // keep Tab inside the open drawer
    if (e.key === 'Tab' && menuOpen()) {
      var f = drawerFocusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });


  /* ---------- mobile login panel: focus in, Tab trap, focus return ---------- */
  var lastAccountOpen = false;
  function loginPanel() { return document.getElementById('login-mobile'); }
  function loginFocusables() {
    var p = loginPanel(); if (!p) return [];
    return Array.prototype.filter.call(p.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
  }
  function onAccountClass() {
    var open = document.body.classList.contains('open_Account');
    if (open === lastAccountOpen) return;
    lastAccountOpen = open;
    var p = loginPanel(); if (!p) return;
    var toggle = $('[data-login-toggle]');
    if (open) {
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () { var f = loginFocusables(); if (f.length) f[0].focus(); else p.focus(); }, 60);
    } else {
      if (toggle) { toggle.setAttribute('aria-expanded', 'false'); if (document.activeElement === document.body || p.contains(document.activeElement)) toggle.focus(); }
    }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !document.body.classList.contains('open_Account')) return;
    var p = loginPanel(); if (!p || p.offsetParent === null) return;
    var f = loginFocusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === p)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  new MutationObserver(onAccountClass).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* ---------- init (re-run when the section is re-rendered in the theme editor) ---------- */
  function init() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    placeNav();
    onScroll();
    lastMenuState = menuOpen();
    syncExpanded();
    observe(document.body, onBodyClass, { attributes: true, attributeFilter: ['class'] });
    var drawer = $('#site-nav-mobile');
    if (drawer) observe(drawer, syncExpanded, { attributes: true, attributeFilter: ['class'], subtree: true });
    var ms = $('.item--searchMobile .navUser-action');
    if (ms) observe(ms, onMobileSearchClass, { attributes: true, attributeFilter: ['class'] });
    $$('[data-cart-count]').forEach(function (n) {
      syncCount(n);
      observe(n, function () { syncCount(n); }, { childList: true, characterData: true, subtree: true });
    });
  }

  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', placeNav);
  else if (DESKTOP.addListener) DESKTOP.addListener(placeNav);
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-cg-header]')) init();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
